import React, { useEffect, useState } from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { ProductReveal } from './ProductReveal';
import { AudienceSection } from './AudienceSection';
import { OldSolutionsSection } from './OldSolutionsSection';
import { ResultsSection } from './ResultsSection';
import { IncludesSection } from './IncludesSection';
import { FinalCTA } from './FinalCTA';
import { StickyMobileCTA } from './StickyMobileCTA';
import { Footer } from './Footer';
export function SalesPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky CTA after scrolling past 600px (approx hero height)
      setShowStickyCTA(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <main className="min-h-screen w-full bg-[#FAF7F2] overflow-x-hidden font-sans text-[#2D2A26]" data-id="element-197">
      <HeroSection data-id="element-198" />
      <PainSection data-id="element-199" />
      <ProductReveal data-id="element-200" />
      <AudienceSection data-id="element-201" />
      <OldSolutionsSection data-id="element-202" />
      <ResultsSection data-id="element-203" />
      <IncludesSection data-id="element-204" />
      <FinalCTA data-id="element-205" />
      <Footer data-id="element-206" />

      <StickyMobileCTA isVisible={showStickyCTA} data-id="element-207" />
    </main>;
}